import useTheme from 'chat-ui/src/hooks/useTheme';
import { useSearchParams } from 'react-router-dom';
import TelletLogo from '@/assets/logo/tellet-logo-main.svg';
import EmpathyLogo from '@/assets/logo/empathy-logo-black.svg';
import Illustration from '@/assets/illustrations/invitation-expired.svg';
import Image from '@/components/atoms/Image';
import { ECompanyThemeName } from '@/enums';

const themeLogosList = {
  [ECompanyThemeName.DEFAULT]: (
    <Image src={TelletLogo} alt="logo" className="absolute w-24 h-fit top-6 left-5" />
  ),
  [ECompanyThemeName.EMPATHY]: (
    <Image src={EmpathyLogo} alt="logo" className="absolute w-44 h-fit top-6 left-5" />
  ),
};

function OrganizationInvitationExpired() {
  const { themeName } = useTheme();
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason');

  const isAlreadyAccepted = reason === 'already_accepted';

  return (
    <div className="relative flex items-center justify-center min-h-screen px-4 mx-auto text-center">
      {themeLogosList[themeName]}
      <div className="flex flex-col items-center justify-center gap-2 mx-auto text-center">
        <Image
          effect="blur"
          src={Illustration}
          alt="illustration"
          className="min500:w-full w-[450px]"
        />
        <h1 className="text-5xl font-bold mt-14 text-dark min500:text-4xl">
          {isAlreadyAccepted
            ? 'Your invitation to organization has already been accepted'
            : 'Your invitation link has expired or been cancelled'}
        </h1>
        <p className="mt-2 text-lg font-semibold">
          {isAlreadyAccepted
            ? 'Get in touch with the organization owner or admins if you think this is wrong.'
            : 'Get in touch with the organization owner or admins to request a new invitation.'}
        </p>
        <p className="mt-2 text-lg font-semibold">
          Visit us at{' '}
          <a
            href="https://tellet.ai"
            className="text-primary underline"
            target="_blank"
            rel="noreferrer"
          >
            tellet.ai
          </a>
          .
        </p>
      </div>
    </div>
  );
}

export default OrganizationInvitationExpired;
